// extracted by mini-css-extract-plugin
export default {"item_wrapper":"Shop_item_wrapper__XZBpF","item_img":"Shop_item_img__SEhA+"};